import { render, staticRenderFns } from "./FormSectionBankAccount.vue?vue&type=template&id=5b2bb761&"
import script from "./FormSectionBankAccount.vue?vue&type=script&lang=js&"
export * from "./FormSectionBankAccount.vue?vue&type=script&lang=js&"
import style0 from "./FormSectionBankAccount.vue?vue&type=style&index=0&id=5b2bb761&prod&lang=css&"
import style1 from "./FormSectionBankAccount.vue?vue&type=style&index=1&id=5b2bb761&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports